import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  name: 'Camila',
  age: 23,
  text: 'Lo había visto en TikTok y no lo encontraba en ninguna librería. Tenerlo digital fue una re buena opción. Lo descargué al toque y ya imprimí las primeras páginas.'
}, {
  name: 'Tomás',
  age: 28,
  text: 'No lo conseguía por ningún lado. Me encantó porque no es el típico sudoku, tiene una vuelta mucho más entretenida con el tema de los crímenes y las pistas.'
}, {
  name: 'Sofía',
  age: 19,
  text: 'Lo compré, lo imprimí y ahora lo estamos completando con mi hermana. Es muy divertido e ingenioso, nos re enganchamos.'
}, {
  name: 'Martina',
  age: 31,
  text: 'Me llegó al instante y se ve muy bien impreso. Me gustó porque no tengo que entrar a ninguna web ni depender del celular.'
}, {
  name: 'Agustín',
  age: 34,
  text: 'Realmente una buena compra. Es ideal para hacer algo distinto a la noche, sin pantalla. Los casos te hacen pensar bastante.'
}, {
  name: 'Valentina',
  age: 26,
  text: 'Lo vi en redes y me dio curiosidad. Me pareció súper original. Ya resolví varios y cada uno tiene su gracia.'
}, {
  name: 'Florencia',
  age: 22,
  text: 'Está muy bueno. Es como mezclar sudoku con investigación. No pensé que me iba a enganchar tanto.'
}];
export const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <div className="relative max-w-4xl mx-auto px-12" data-id="element-146">
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F4D35E] transition-colors z-10" data-id="element-147">
        <ChevronLeft size={24} data-id="element-148" />
      </button>

      <div className="overflow-hidden py-4" data-id="element-149">
        <AnimatePresence mode="wait" data-id="element-150">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#7B2CBF]" data-id="element-151">
            <div className="flex items-center gap-4 mb-4" data-id="element-152">
              <div className="w-12 h-12 bg-[#F6E7A1] rounded-full flex items-center justify-center text-[#5E1A8A] font-bold text-xl" data-id="element-153">
                {testimonials[currentIndex].name.charAt(0)}
              </div>
              <div data-id="element-154">
                <h4 className="font-heading font-bold text-lg text-[#1E1E1E]" data-id="element-155">
                  {testimonials[currentIndex].name},{' '}
                  {testimonials[currentIndex].age} años
                </h4>
                <div className="flex text-[#F4D35E]" data-id="element-156">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-157" />)}
                </div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-158">
              "{testimonials[currentIndex].text}"
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F4D35E] transition-colors z-10" data-id="element-159">
        <ChevronRight size={24} data-id="element-160" />
      </button>

      <div className="flex justify-center gap-2 mt-6" data-id="element-161">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-[#7B2CBF]' : 'bg-gray-300'}`} data-id="element-162" />)}
      </div>
    </div>;
};